import { CUSTOMER, IMAGE_BASE_URL } from "./constants.jsx";
import { LocalStorageUtils } from "./localstorage.utils.jsx";
import { nanoid } from "nanoid";
import { CookieUtils } from "./cookie.utils.jsx";

export const getImageUrl = (imageName) => {
  return `${IMAGE_BASE_URL}${imageName}`;
};

export const stringToTitleCase = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export function getDeviceId() {
  let mobileDeviceId = CookieUtils.get(
    LocalStorageUtils.LOCAL_STORAGE_KEY.MOBILE_APP_DEVICE_ID
  );
  if (mobileDeviceId) {
    return mobileDeviceId;
  }

  const webDeviceId = LocalStorageUtils.get(
    LocalStorageUtils.LOCAL_STORAGE_KEY.WEB_DEVICE_ID
  );
  if (webDeviceId) {
    return webDeviceId;
  }

  const deviceId = nanoid();
  LocalStorageUtils.set(
    LocalStorageUtils.LOCAL_STORAGE_KEY.WEB_DEVICE_ID,
    deviceId
  );
  return deviceId;
}

export function getDeviceType() {
  const mobileDeviceType = CookieUtils.get(
    LocalStorageUtils.LOCAL_STORAGE_KEY.MOBILE_APP_DEVICE_TYPE
  );
  if (mobileDeviceType) {
    return mobileDeviceType;
  }

  return CUSTOMER.USER_DEVICE_TYPE.CustomerWebApp;
}

export function getNotificationToken() {
  const mobileNotificationToken = CookieUtils.get(
    LocalStorageUtils.LOCAL_STORAGE_KEY.MOBILE_APP_NOTIFICATION_TOKEN
  );
  if (mobileNotificationToken) {
    return mobileNotificationToken;
  }

  const webNotificationToken = LocalStorageUtils.get(
    LocalStorageUtils.LOCAL_STORAGE_KEY.WEB_NOTIFICATION_TOKEN
  );
  if (webNotificationToken) {
    return webNotificationToken;
  }

  return null;
}

export function getDeviceDetails() {
  const mobileDeviceDetails = CookieUtils.get(
    LocalStorageUtils.LOCAL_STORAGE_KEY.MOBILE_APP_DEVICE_DETAILS
  );
  if (mobileDeviceDetails) {
    return mobileDeviceDetails;
  }

  const webDeviceDetails = LocalStorageUtils.get(
    LocalStorageUtils.LOCAL_STORAGE_KEY.WEB_DEVICE_DETAILS
  );
  if (webDeviceDetails) {
    return webDeviceDetails;
  }
}

export function getLocation() {
  const mobileLocation = CookieUtils.get(
    LocalStorageUtils.LOCAL_STORAGE_KEY.MOBILE_APP_LOCATION
  );
  if (mobileLocation) {
    return mobileLocation;
  }

  return null;
}

export function isShowCustomerProductPage() {
  const deviceType = getDeviceType();
  if(deviceType === CUSTOMER.USER_DEVICE_TYPE.CustomerWebApp) {
    return true;
  }

  const deviceDetails = getDeviceDetails();
  if(deviceDetails && deviceDetails.appBuild && parseInt(deviceDetails.appBuild) >= 8) {
    return true;
  }

  return false;
}
